<template>
	<div class="img-list">
		<div style="width:100%;display:flex;justify-content: center;width: 350px;" v-if="file.length==0 && type ==1">
			<figure style="text-align: center;">
				<img src="@/assets/kong.png" alt="" srcset=""  style="width:78px;height: 78px;"/>
				<figcaption>暂无数据</figcaption>
			</figure>
		</div>
		<div class="img-item" v-for="(item, index) in file" :key="index" :style="imageStyle">
			<el-image
				v-if="isImage(item)"
				:src="item"
				:preview-src-list="[item]"
				class="img"
				:style="imageStyle"
				fit="cover"
			/>
			<el-image
				v-else-if="isPdf(item)"
				:src="require('@/assets/img2.png')"
				class="img"
				:style="imageStyle"
				fit="cover"
				@click.native="downloadFile(item)"
			/>
			<el-image
				v-else-if="isZip(item)"
				:src="require('@/assets/img3.png')"
				class="img"
				:style="imageStyle"
				fit="cover"
				@click.native="downloadFile(item)"
			/>
			<el-image v-else :src="zipCover" class="img" :style="imageStyle" fit="cover" />
		</div>
	</div>
</template>

<script>
export default {
	name: "imglist",
	props: {
		file: {
			type: Array,
			default: () => []
		},
		type: {},
		width:{
			type: String,
			 default: '72px'
		}, 
		height:{
			type: String,
			default: '78px'
		},
		color:{
			type: String,
			default: '#FF5900'
		}
	},
	computed: {
		imageStyle() {
			return {
				width: this.width,
				height: this.height,
				color:this.color,
				
			};
		}
	},
	data() {
		return {
			pdfCover: "/assets/img2.png",
			zipCover: "/assets/img3.png"
		};
	},
	
	methods: {
		getExt(url) {
			const cleanUrl = url.split("?")[0].split("#")[0];
			const parts = cleanUrl.split(".");
			return parts.length > 1 ? parts.pop().toLowerCase() : "";
		},
		isImageExt(ext) {
			return ["png", "jpg", "jpeg", "gif", "webp", "bmp",].includes(ext);
		},
		isImage(url) {
			return this.isImageExt(this.getExt(url));
		},
		isPdf(url) {
			return this.getExt(url) === "pdf";
		},
		isZip(url) {
			return this.getExt(url) === "zip";
		},
		downloadFile(url) {
			if (!url) return;
			const link = document.createElement("a");
			link.href = url;
			link.target = "_blank";
			link.download = "";
			document.body.appendChild(link);
			link.click();
			document.body.removeChild(link);
		}
	}
};
</script>

<style>
.img-list {
	display: flex;
	flex-wrap: wrap;
}

.img-item {
	width:72px;
	height: 78px;
	margin-right: 16rpx;
	border-radius: 8rpx;
	overflow: hidden;
	margin-right:10px;
/* 	background-color: #f6f6f6; */
}

.img {
	width: 100%;
	height: 100%;
	border-radius:4px;
}
</style>